import { EmailStatsWhenSent } from '@dto/rates/email-stats-when-sent.dto';
import { ProvidersStats } from '@dto/rates/providers-stats';
import { ThresholdByProductId } from '@dto/threshold/threshold.dto';
import { HistogramMailSent } from '@entity/charts/histogram-sent-mail.entity';
import { FilterData } from '@entity/filter-data.entity';
import { createAction, props } from '@ngrx/store';
import { GranularityType } from '@type/granularity.type';

const state = '[Dashboard]';

// Init allowed productIds
export const initAllowedProductIds = createAction(
  `${state} Init allowed productIds`,
  props<{ productIds: string[] }>()
);
// Init all charts
export const initAllCharts = createAction(
  `${state} Init all charts`,
  props<{ filters: FilterData }>()
);

// ---- change dashboard filters ----
export const changeDashboardFilters = createAction(
  `${state} Change dashboard filter`,
  props<{ filters: FilterData }>()
);
export const changeDashboardFiltersSuccess = createAction(
  `${state} Change dashboard filter success`,
  props<{ filters: FilterData, eventTypeData: string[] }>()
);
export const changeDashboardFiltersFailure = createAction(
  `${state} Change dashboard filter failure`,
  props<{ error: string, filters: FilterData, eventTypeData: string[] }>()
);

//////

////// Histogram
// change granularity
export const changeHistogramGranularity = createAction(
  `${state} Change histogram granularity`,
  props<{ granularity: GranularityType }>()
);
// data
export const retrieveHistogramData = createAction(
  `${state} Retrieve histogram data`,
  props<{ filters: FilterData, granularity: GranularityType }>()
);
export const retrieveHistogramDataSuccess = createAction(
  `${state} Retrieve histogram data success`,
  props<{ histogramData: HistogramMailSent }>()
);
export const retrieveHistogramDataFailure = createAction(
  `${state} Retrieve histogram data failure`,
  props<{ error: string }>()
);

////// Deliverability Indicators
export const retrieveDeliverabilityIndicators = createAction(
  `${state} Retrieve deliverability indicators`,
  props<{ filters: FilterData }>()
);
export const retrieveDeliverabilityIndicatorsSuccess = createAction(
  `${state} Retrieve deliverability indicators success`,
  props<{ allOnPeriod: EmailStatsWhenSent, yesterday: EmailStatsWhenSent, lastSevenFullDays: EmailStatsWhenSent }>()
);
export const retrieveDeliverabilityIndicatorsFailure = createAction(
  `${state} Retrieve deliverability indicators failure`,
  props<{ error: string }>()
);


////// Thresholds
export const retrieveThresholdData = createAction(
  `${state} Retrieve threshold data`,
  props<{ productIds: string[] }>()
);
export const retrieveThresholdDataSuccess = createAction(
  `${state} Retrieve threshold data success`,
  props<{ thresholdData: ThresholdByProductId }>()
);
export const retrieveThresholdDataFailure = createAction(
  `${state} Retrieve threshold data failure`,
  props<{ error: string }>()
);

////// Providers Stats
export const retrieveProvidersStatsData = createAction(
  `${state} Retrieve providers stats data`,
  props<{ filters: FilterData }>()
);
export const retrieveProvidersStatsDataSuccess = createAction(
  `${state} Retrieve providers stats data success`,
  props<{ allOnPeriod: ProvidersStats, yesterday: ProvidersStats }>()
);
export const retrieveProvidersStatsDataFailure = createAction(
  `${state} Retrieve providers stats data failure`,
  props<{ error: string }>()
);


